var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLeaf = function SvgLeaf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 17,
    fill: "none",
    "aria-labelledby": "svgTitle",
    viewBox: "0 0 19 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C7F0AE",
    d: "M.358.993A20 20 0 0 0 .126 3.77c0 6.385 3.762 10.624 9.459 10.624 3.143 0 5.193-1.695 5.75-3.032l-.774.145c1.048 1.152 1.445 2.202 2.073 4.18.127.397.406.538.698.538.616 0 1.08-.529 1.08-1.264 0-1.244-1.596-3.298-2.47-4.117C12.274 7.42 6.864 9.408 5.072 5.77c-.144-.293.16-.522.425-.25 2.913 2.88 6.62.437 10.454 3.911.224.198.51.104.553-.166.046-.28.068-.677.068-1.102 0-4.088-2.846-6.01-6.967-6.01-1.335 0-2.8.24-4.05.24-1.637 0-3.279-.226-4.406-1.583C.874.497.444.56.358.993"
  })));
};
export default SvgLeaf;